const messages = {
    custom: {
      	cadastro_de_cartao_social__numero: {
      		 required: 'O número do cartão social deve ser preenchida.'
    	},
      	cadastro_de_cartao_social__nome: {
      		 required: 'O nome do beneficiário deve ser preenchida.'
    	},
        datanascimento: {
            datanasc: 'A data de nascimento está incorreta.',
            required: 'A data deve ser preenchida.',
			idadecompat: 'A data de nascimento não é compatível com o plano selecionado.'
        },
        nome: {
        	required: 'O campo deve ser preenchido.',
        	alpha_spaces: 'O valor inserido é inválido.'
        },
        sobrenome: {
        	required: 'O campo deve ser preenchido.',
        	alpha_spaces: 'O valor inserido é inválido.'
        },
        email: {
        	required: 'O campo deve ser preenchido.',
            email: 'Informe um endereço de e-mail válido.',
            login_hibrido: 'E-mail ou CPF é inválido.'
        },
        cpf: {
        	required: 'O CPF DEVE SER PREENCHIDO.',
        	cpf: 'OPS! CPF INVÁLIDO. TENTE NOVAMENTE!'
        },
        celular: {
        	required: 'O campo deve ser preenchido.',
        	min: 'O valor inserido deve conter no mínimo 11 caracteres.'
        },
        sexo: {
        	required: 'Informe o sexo.'
        },
        password: {
        	required: 'O campo deve ser preenchido.',
        	min: 'O valor inserido deve conter no mínimo 6 caracteres.',
        	confirmed: 'As senhas informadas são diferentes.'
        },
        password_confirm: {
        	required: 'O campo deve ser preenchido.',
        },
        termoscontrato: {
        	required: 'Você deve aceitar os termos do contrato para avançar.',
        },
        cep: {
        	required: 'Informe seu CEP.',
            prefix: 'Seu CEP não é válido para este plano',
            not_prefix: 'Seu CEP não é válido para este plano',
        },
        endereco: {
        	required: 'O campo deve ser preenchido.',
        },
        bairro: {
        	required: 'O campo deve ser preenchido.',
        },
        numero: {
        	required: 'O campo deve ser preenchido.',
        },
        estado: {
        	required: 'Selecione seu estado.',
        },
        cidade: {
        	required: 'Selecione sua cidade.',
        },
        temDependentes:{
        	required: 'Selecione uma opção',
        	included: 'Opção inválida'
		},
		valorlivre:{
        	minimum_price: 'Valor livre incompatível.'
        },

    /* ---------------------- DEPENDENTES --------------------*/

    	/* ----- PLANO 00 --------*/

	        /* DEPENDENTE 00 */

        nomeCompleto_0_0:{
            alpha_spaces: 'O valor inserido é inválido.',
        },
        email_0_0:{
            email: 'Informe um endereço de e-mail válido.',
        },
        dataNascimento_0_0:{
            required: 'O campo deve ser preenchido.',
            datanasc: 'Data de nacimento incorreta.',
            idadecompat: 'A data de nascimento não é compatível com o plano selecionado.'
        },
	        
        /* DEPENDENTE 01 */

        nomeCompleto_0_1:{
            alpha_spaces: 'O valor inserido é inválido.',
        },
        email_0_1:{
            email: 'Informe um endereço de e-mail válido.',
        },
        dataNascimento_0_1:{
            required: 'O campo deve ser preenchido.',
            datanasc: 'Data de nacimento incorreta.',
            idadecompat: 'A data de nascimento não é compatível com o plano selecionado.'
        },

        /* DEPENDENTE 02 */

        nomeCompleto_0_2:{
            alpha_spaces: 'O valor inserido é inválido.',
        },
        email_0_2:{
            email: 'Informe um endereço de e-mail válido.',
        },
        dataNascimento_0_2:{
            required: 'O campo deve ser preenchido.',
            datanasc: 'Data de nacimento incorreta.',
            idadecompat: 'A data de nascimento não é compatível com o plano selecionado.'
        },

        /* DEPENDENTE 03 */

        nomeCompleto_0_3:{
            alpha_spaces: 'O valor inserido é inválido.',
        },
        email_0_3:{
            email: 'Informe um endereço de e-mail válido.',
        },
        dataNascimento_0_3:{
            required: 'O campo deve ser preenchido.',
            datanasc: 'Data de nacimento incorreta.',
            idadecompat: 'A data de nascimento não é compatível com o plano selecionado.'
        },

        /* DEPENDENTE 04 */

        nomeCompleto_0_4:{
            alpha_spaces: 'O valor inserido é inválido.',
        },
        email_0_4:{
            email: 'Informe um endereço de e-mail válido.',
        },
        dataNascimento_0_4:{
            required: 'O campo deve ser preenchido.',
            datanasc: 'Data de nacimento incorreta.',
            idadecompat: 'A data de nascimento não é compatível com o plano selecionado.'
        },

        /* DEPENDENTE 05 */

        nomeCompleto_0_5:{
            alpha_spaces: 'O valor inserido é inválido.',
        },
        email_0_5:{
            email: 'Informe um endereço de e-mail válido.',
        },
        dataNascimento_0_5:{
            required: 'O campo deve ser preenchido.',
            datanasc: 'Data de nacimento incorreta.',
            idadecompat: 'A data de nascimento não é compatível com o plano selecionado.'
        },

        /* DEPENDENTE 06 */

        nomeCompleto_0_6:{
            alpha_spaces: 'O valor inserido é inválido.',
        },
        email_0_6:{
            email: 'Informe um endereço de e-mail válido.',
        },
        dataNascimento_0_6:{
            required: 'O campo deve ser preenchido.',
            datanasc: 'Data de nacimento incorreta.',
            idadecompat: 'A data de nascimento não é compatível com o plano selecionado.'
        },

        /* DEPENDENTE 07 */

        nomeCompleto_0_7:{
            alpha_spaces: 'O valor inserido é inválido.',
        },
        email_0_7:{
            email: 'Informe um endereço de e-mail válido.',
        },
        dataNascimento_0_7:{
            required: 'O campo deve ser preenchido.',
            datanasc: 'Data de nacimento incorreta.',
            idadecompat: 'A data de nascimento não é compatível com o plano selecionado.'
        },

        /* DEPENDENTE 08 */

        nomeCompleto_0_8:{
            alpha_spaces: 'O valor inserido é inválido.',
        },
        email_0_8:{
            email: 'Informe um endereço de e-mail válido.',
        },
        dataNascimento_0_8:{
            required: 'O campo deve ser preenchido.',
            datanasc: 'Data de nacimento incorreta.',
            idadecompat: 'A data de nascimento não é compatível com o plano selecionado.'
        },

        /* DEPENDENTE 09 */

        nomeCompleto_0_9:{
            alpha_spaces: 'O valor inserido é inválido.',
        },
        email_0_9:{
            email: 'Informe um endereço de e-mail válido.',
        },
        dataNascimento_0_9:{
            required: 'O campo deve ser preenchido.',
            datanasc: 'Data de nacimento incorreta.',
            idadecompat: 'A data de nascimento não é compatível com o plano selecionado.'
        },

        /* DEPENDENTE 10 */

        nomeCompleto_0_10:{
            alpha_spaces: 'O valor inserido é inválido.',
        },
        email_0_10:{
            email: 'Informe um endereço de e-mail válido.',
        },
        dataNascimento_0_10:{
            required: 'O campo deve ser preenchido.',
            datanasc: 'Data de nacimento incorreta.',
            idadecompat: 'A data de nascimento não é compatível com o plano selecionado.'
        },
  	
  	
  	    /* ----- PLANO 01 --------*/

  		/* DEPENDENTE 00 */

        nomeCompleto_1_0:{
        	alpha_spaces: 'O valor inserido é inválido.',
        },
        email_1_0:{
        	email: 'Informe um endereço de e-mail válido.',
        },
        dataNascimento_1_0:{
        	required: 'O campo deve ser preenchido.',
        	datanasc: 'Data de nacimento incorreta.',
        	idadecompat: 'A data de nascimento não é compatível com o plano selecionado.'
        },
        
        /* DEPENDENTE 01 */

        nomeCompleto_1_1:{
        	alpha_spaces: 'O valor inserido é inválido.',
        },
        email_1_1:{
        	email: 'Informe um endereço de e-mail válido.',
        },
        dataNascimento_1_1:{
        	required: 'O campo deve ser preenchido.',
        	datanasc: 'Data de nacimento incorreta.',
        	idadecompat: 'A data de nascimento não é compatível com o plano selecionado.'
        },

        /* DEPENDENTE 02 */

        nomeCompleto_1_2:{
        	alpha_spaces: 'O valor inserido é inválido.',
        },
        email_1_2:{
        	email: 'Informe um endereço de e-mail válido.',
        },
        dataNascimento_1_2:{
        	required: 'O campo deve ser preenchido.',
        	datanasc: 'Data de nacimento incorreta.',
        	idadecompat: 'A data de nascimento não é compatível com o plano selecionado.'
        },

        /* DEPENDENTE 03 */

        nomeCompleto_1_3:{
        	alpha_spaces: 'O valor inserido é inválido.',
        },
        email_1_3:{
        	email: 'Informe um endereço de e-mail válido.',
        },
        dataNascimento_1_3:{
        	required: 'O campo deve ser preenchido.',
        	datanasc: 'Data de nacimento incorreta.',
        	idadecompat: 'A data de nascimento não é compatível com o plano selecionado.'
        },

        /* DEPENDENTE 04 */

        nomeCompleto_1_4:{
        	alpha_spaces: 'O valor inserido é inválido.',
        },
        email_1_4:{
        	email: 'Informe um endereço de e-mail válido.',
        },
        dataNascimento_1_4:{
        	required: 'O campo deve ser preenchido.',
        	datanasc: 'Data de nacimento incorreta.',
        	idadecompat: 'A data de nascimento não é compatível com o plano selecionado.'
        },

        /* DEPENDENTE 05 */

        nomeCompleto_1_5:{
        	alpha_spaces: 'O valor inserido é inválido.',
        },
        email_1_5:{
        	email: 'Informe um endereço de e-mail válido.',
        },
        dataNascimento_1_5:{
        	required: 'O campo deve ser preenchido.',
        	datanasc: 'Data de nacimento incorreta.',
        	idadecompat: 'A data de nascimento não é compatível com o plano selecionado.'
        },

        /* DEPENDENTE 06 */

        nomeCompleto_1_6:{
        	alpha_spaces: 'O valor inserido é inválido.',
        },
        email_1_6:{
        	email: 'Informe um endereço de e-mail válido.',
        },
        dataNascimento_1_6:{
        	required: 'O campo deve ser preenchido.',
        	datanasc: 'Data de nacimento incorreta.',
        	idadecompat: 'A data de nascimento não é compatível com o plano selecionado.'
        },

        /* DEPENDENTE 07 */

        nomeCompleto_1_7:{
        	alpha_spaces: 'O valor inserido é inválido.',
        },
        email_1_7:{
        	email: 'Informe um endereço de e-mail válido.',
        },
        dataNascimento_1_7:{
        	required: 'O campo deve ser preenchido.',
        	datanasc: 'Data de nacimento incorreta.',
        	idadecompat: 'A data de nascimento não é compatível com o plano selecionado.'
        },

        /* DEPENDENTE 08 */

        nomeCompleto_1_8:{
        	alpha_spaces: 'O valor inserido é inválido.',
        },
        email_1_8:{
        	email: 'Informe um endereço de e-mail válido.',
        },
        dataNascimento_1_8:{
        	required: 'O campo deve ser preenchido.',
        	datanasc: 'Data de nacimento incorreta.',
        	idadecompat: 'A data de nascimento não é compatível com o plano selecionado.'
        },

        /* DEPENDENTE 09 */

        nomeCompleto_1_9:{
        	alpha_spaces: 'O valor inserido é inválido.',
        },
        email_1_9:{
        	email: 'Informe um endereço de e-mail válido.',
        },
        dataNascimento_1_9:{
        	required: 'O campo deve ser preenchido.',
        	datanasc: 'Data de nacimento incorreta.',
        	idadecompat: 'A data de nascimento não é compatível com o plano selecionado.'
        },

        /* DEPENDENTE 10 */

        nomeCompleto_1_10:{
        	alpha_spaces: 'O valor inserido é inválido.',
        },
        email_1_10:{
        	email: 'Informe um endereço de e-mail válido.',
        },
        dataNascimento_1_10:{
        	required: 'O campo deve ser preenchido.',
        	datanasc: 'Data de nacimento incorreta.',
        	idadecompat: 'A data de nascimento não é compatível com o plano selecionado.'
        },
  	
  	    /* ----- PLANO 02 --------*/

  		/* DEPENDENTE 00 */

        nomeCompleto_2_0:{
        	alpha_spaces: 'O valor inserido é inválido.',
        },
        email_2_0:{
        	email: 'Informe um endereço de e-mail válido.',
        },
        dataNascimento_2_0:{
        	required: 'O campo deve ser preenchido.',
        	datanasc: 'Data de nacimento incorreta.',
        	idadecompat: 'A data de nascimento não é compatível com o plano selecionado.'
        },
        
        /* DEPENDENTE 01 */

        nomeCompleto_2_1:{
        	alpha_spaces: 'O valor inserido é inválido.',
        },
        email_2_1:{
        	email: 'Informe um endereço de e-mail válido.',
        },
        dataNascimento_2_1:{
        	required: 'O campo deve ser preenchido.',
        	datanasc: 'Data de nacimento incorreta.',
        	idadecompat: 'A data de nascimento não é compatível com o plano selecionado.'
        },

        /* DEPENDENTE 02 */

        nomeCompleto_2_2:{
        	alpha_spaces: 'O valor inserido é inválido.',
        },
        email_2_2:{
        	email: 'Informe um endereço de e-mail válido.',
        },
        dataNascimento_2_2:{
        	required: 'O campo deve ser preenchido.',
        	datanasc: 'Data de nacimento incorreta.',
        	idadecompat: 'A data de nascimento não é compatível com o plano selecionado.'
        },

        /* DEPENDENTE 03 */

        nomeCompleto_2_3:{
        	alpha_spaces: 'O valor inserido é inválido.',
        },
        email_2_3:{
        	email: 'Informe um endereço de e-mail válido.',
        },
        dataNascimento_2_3:{
        	required: 'O campo deve ser preenchido.',
        	datanasc: 'Data de nacimento incorreta.',
        	idadecompat: 'A data de nascimento não é compatível com o plano selecionado.'
        },

        /* DEPENDENTE 04 */

        nomeCompleto_2_4:{
        	alpha_spaces: 'O valor inserido é inválido.',
        },
        email_2_4:{
        	email: 'Informe um endereço de e-mail válido.',
        },
        dataNascimento_2_4:{
        	required: 'O campo deve ser preenchido.',
        	datanasc: 'Data de nacimento incorreta.',
        	idadecompat: 'A data de nascimento não é compatível com o plano selecionado.'
        },

        /* DEPENDENTE 05 */

        nomeCompleto_2_5:{
        	alpha_spaces: 'O valor inserido é inválido.',
        },
        email_2_5:{
        	email: 'Informe um endereço de e-mail válido.',
        },
        dataNascimento_2_5:{
        	required: 'O campo deve ser preenchido.',
        	datanasc: 'Data de nacimento incorreta.',
        	idadecompat: 'A data de nascimento não é compatível com o plano selecionado.'
        },

        /* DEPENDENTE 06 */

        nomeCompleto_2_6:{
        	alpha_spaces: 'O valor inserido é inválido.',
        },
        email_2_6:{
        	email: 'Informe um endereço de e-mail válido.',
        },
        dataNascimento_2_6:{
        	required: 'O campo deve ser preenchido.',
        	datanasc: 'Data de nacimento incorreta.',
        	idadecompat: 'A data de nascimento não é compatível com o plano selecionado.'
        },

        /* DEPENDENTE 07 */

        nomeCompleto_2_7:{
        	alpha_spaces: 'O valor inserido é inválido.',
        },
        email_2_7:{
        	email: 'Informe um endereço de e-mail válido.',
        },
        dataNascimento_2_7:{
        	required: 'O campo deve ser preenchido.',
        	datanasc: 'Data de nacimento incorreta.',
        	idadecompat: 'A data de nascimento não é compatível com o plano selecionado.'
        },

        /* DEPENDENTE 08 */

        nomeCompleto_2_8:{
        	alpha_spaces: 'O valor inserido é inválido.',
        },
        email_2_8:{
        	email: 'Informe um endereço de e-mail válido.',
        },
        dataNascimento_2_8:{
        	required: 'O campo deve ser preenchido.',
        	datanasc: 'Data de nacimento incorreta.',
        	idadecompat: 'A data de nascimento não é compatível com o plano selecionado.'
        },

        /* DEPENDENTE 09 */

        nomeCompleto_2_9:{
        	alpha_spaces: 'O valor inserido é inválido.',
        },
        email_2_9:{
        	email: 'Informe um endereço de e-mail válido.',
        },
        dataNascimento_2_9:{
        	required: 'O campo deve ser preenchido.',
        	datanasc: 'Data de nacimento incorreta.',
        	idadecompat: 'A data de nascimento não é compatível com o plano selecionado.'
        },

        /* DEPENDENTE 10 */

        nomeCompleto_2_10:{
        	alpha_spaces: 'O valor inserido é inválido.',
        },
        email_2_10:{
        	email: 'Informe um endereço de e-mail válido.',
        },
        dataNascimento_2_10:{
        	required: 'O campo deve ser preenchido.',
        	datanasc: 'Data de nacimento incorreta.',
        	idadecompat: 'A data de nascimento não é compatível com o plano selecionado.'
        },
    }
};

export default messages;
